import AboutPage from "./components/about";
import Navmenu from "./components/navmenu";
import HomePage from "./components/home";
import RecentProjects from "./components/recentProjects";
import Contact from "./components/contact";
import Testimonial from "./components/testimonial";
import Education from "./components/education";

export default function Home() {

  return (
    <>
      <Navmenu />
      <HomePage />
      <AboutPage />
      <Education />
      <RecentProjects />
      <Testimonial />
      <Contact />
    </>
  );
}
